import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TryGetLangFromStorage } from 'projects/components/language-selector/try-get-lang-from.storage';
import { Observable } from 'rxjs';
import { TokenService } from '../../services/auth/token.service';

@Injectable()
export class PayLoginHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const tokenService = inject(TokenService);
    const sessionToken = tokenService.accessToken;
    const language = TryGetLangFromStorage();

    let headerLang = 'nl-NL';
    switch (language.toLowerCase()) {
      case 'en':
        headerLang = 'en-GB';
        break;
      case 'fr':
        headerLang = 'fr-FR';
        break;
      case 'de':
        headerLang = 'de-DE';
        break;
      case 'nl':
      default:
        headerLang = 'nl-NL';
        break;
    }

    if (sessionToken && !req.headers.has('Authorization')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${sessionToken}`,
        },
      });
    }

    // strip headers, PAY's CORS policy will reject requests with custom headers
    if (req.url.includes('pay.nl') || req.url.includes('tintel.dev')) {
      const cleanedHeaders = req.headers
        .keys()
        .filter((x) => !['cache-key', 'x-pay-env'].includes(x))
        .reduce((headers, key) => {
          return headers.set(key, req.headers.get(key)!);
        }, new HttpHeaders());

      req = req.clone({
        withCredentials: true,
        headers: cleanedHeaders,
      });

      req = req.clone({
        setHeaders: {
          'Accept-Language': headerLang,
        },
      });
    }

    return next.handle(req);
  }
}
